import PageProps from '@leuven2030/food/Page/PageProps';
import Button from '@material-ui/core/Button/Button';
import { gql } from '@apollo/client';
import { AllPartnersQuery } from '@leuven2030/framework/Partner/PartnersQuery';
import Page, { PageContext } from '@leuven2030/framework/Page/Page';
import ContentCover, {
  ContentCoverTitle
} from '@leuven2030/framework/Content/ContentCover';
import React, { useContext } from 'react';
import 'twin.macro';
import ContentPrismic from '@leuven2030/framework/Content/ContentPrismic';
import { StyleContent } from '@leuven2030/food/styles/general';
import ContentSource from '@leuven2030/framework/Content/ContentSource';
import Image from '@leuven2030/framework/Image/Image';
import PagePaths from '@leuven2030/food/Page/PagePaths';
import PageFallback from '@leuven2030/food/Page/PageFallback';
import Page404 from '@leuven2030/food/Page/Page404';
import { useRouter } from 'next/router';
import PageLayoutDefault from '@leuven2030/food/Page/PageLayoutDefault';
import { ContentQuoteQuery } from '@leuven2030/framework/Content/ContentQuote';
import ContentQuote from '@leuven2030/food/Content/ContentQuote';
import NavigationLink from '@leuven2030/framework/Navigation/NavigationLink';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import IconButton from '@material-ui/IconButton';

const FoodPartnerPage = Page(() => {
  const {
    prismic: { partner, partners_page }
  } = useContext(PageContext);
  const router = useRouter();

  if (router.isFallback) {
    return <PageFallback />;
  }

  if (!partner) {
    return <Page404 />;
  }

  const { cover, body, title, link, logo } = partner;

  return (
    <PageLayoutDefault>
      <ContentCover image={cover}>
        <div tw="flex flex-col justify-between h-full">
          <div tw="flex flex-row justify-center items-center h-full">
            {logo && (
              <Image
                src={logo.url}
                imgixParams={{
                  w: 150,
                  h: 150
                }}
              />
            )}
          </div>
        </div>
        <div tw="flex items-center">
          <div tw="text-primary-300 text-lg flex items-center">
            <KeyboardArrowLeft />
            <NavigationLink prismicMeta={partners_page}>
              <h3>All partners</h3>
            </NavigationLink>
          </div>
        </div>
      </ContentCover>

      <div tw="" css={StyleContent}>
        <div tw="py-6">
          <h1 tw="text-4xl text-gray-800">{title}</h1>
          <div tw="text-primary-400 py-6">
            {link && <ContentSource url={link.url} />}
          </div>
        </div>
        <ContentPrismic
          slices={body}
          tw="pb-12"
          SliceComponents={[ContentQuote]}
        />
        <div tw="py-12">
          <NavigationLink prismicMeta={partners_page}>
            <Button
              variant="outlined"
              tw="mx-auto bg-primary-400 text-white border-transparent hover:bg-primary-200 w-48"
            >
              {'Partners'}
            </Button>
          </NavigationLink>
        </div>
      </div>
    </PageLayoutDefault>
  );
});

const SchoolPage = (props) => <FoodPartnerPage {...props} />;

export const getStaticProps = PageProps({
  prismic: {
    query: gql`
        query($uid:String!){
            partners_page(uid:"partners",lang:"nl-be"){
                _meta{
                    uid
                    type
                }
            }
            partner(uid:$uid, lang:"nl-be"){
                title
                cover{
                    ... on _ImageLink{
                        url
                    }
                }
                link{
                    ... on _ExternalLink{
                        url
                    }
                    ... on _Document{
                        _meta{
                            uid
                            type
                        }
                    }
                }
                logo{
                    ... on _ImageLink{
                        url
                    }
                }
                body{
                    ... on PartnerBodyRich_text{
                        type
                        primary{
                            text
                        }
                    }
                    ${ContentQuoteQuery({ typeName: 'Partner' })}
                }
            }
            ${AllPartnersQuery}
        }
        `,
    onContext: ({ params }, { setVariables }) => {
      const { uid } = params;
      setVariables({
        uid
      });
    }
  }
});

export const getStaticPaths = PagePaths({
  type: 'partner'
});

export default SchoolPage;
